export default "__VITE_ASSET__Bxk7ORjO__"